import { merge } from 'lodash';
import ReactApexChart from 'react-apexcharts';
import { useState, useEffect } from "react";
// material
import { Box, Card, CardHeader, Stack, Typography } from '@mui/material';
// utils
import { fNumber } from '../../../utils/formatNumber';
//
import { BaseOptionChart } from '../../charts';

// ----------------------------------------------------------------------



function AppPracticePrescriptions2(props) {
  const [data, setData] = useState([]);
  const categories2 = [
    'Big City',
    'Small Town',
    'Rural',
    'Sub-urban',
    'Mixed Rural / Urban'
  ];
  const categories = {
    'Big (inner city)': 'Big City',
    'Small (town)': 'Small Town',
    'Rural': 'Rural',
    'Suburbs': 'Sub-urban',
    'Mixed urban-rural': 'Mixed Rural / Urban'
  };

  const fillColor = {
    'Big City': '#3E8397',
    'Small Town': '#3E8397CC',
    'Rural': '#3E839799',
    'Sub-urban': '#3E839766',
    'Mixed Rural / Urban': '#3E839733'
  }
  useEffect(() => {

    if (props.practices_data) {
      // Map display names to practiceCount
      const areaMap = {};
      if(props.practices_data.places){
        props.practices_data.places.forEach(area => {
          const displayName = categories[area.name];
          if (displayName) {
            areaMap[displayName] = area.practiceCount;
          }
        });
      }

      // Ensure all categories are present, missing ones get y: 0
      const chartData = categories2.map(cat => ({
        x: cat,
        y: areaMap[cat] || 0,
        fillColor: fillColor[cat]
      }));

      setData(chartData);
    }


  }, [props.practices_data]);
  const CHART_DATA_PrescriptionsWeekDay = [{
    name: 'Practices',
    data: data
  }];

  const chartOptions = merge(BaseOptionChart(), {
    colors: CHART_DATA_PrescriptionsWeekDay[0].data.map(item => item.fillColor),
    labels: ['Big City', 'Small Town', 'Rural', 'Sub-urban', 'Mixed Rural / Urban'],
    legend: { 
      show: false  // Hide the legend
    },
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return val.toFixed(0) + "%"
      },
      style: {
        fontSize: '15px',
        fontWeight: 'bold',
        colors: ['#fff']
      },
    },
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: true,
            name: {
              show: true,
              fontSize: '14px',
              color: '#22577A'
            },
            value: {
              show: true,
              fontSize: '14px',
              color: '#3E8397',
              formatter: function (val) {
                return val.toFixed(0) + '%'
              }
            },
            total: {
              show: false
            }
          },
          size: '50%'
        },
        expandOnClick: false
      }
    },
    tooltip: {
      y: {
        formatter: (value) => fNumber(value)
      }
    }
  });

  return (
    <Card sx={{ boxShadow: 'none', mt: 4, height: 400 }} >
      <Typography variant="h4" color="#22577A" sx={{ mb: 2, px: 2 }}>
        General practices area
      </Typography>
      <Box sx={{ mt: 4, mx: 5, width: 450, height: 370 }} dir="ltr">
        <ReactApexChart
          type="donut"
          series={CHART_DATA_PrescriptionsWeekDay[0].data.map(item => item.y)}
          options={chartOptions}
          height={350}
        />
      </Box>
    </Card>
  );
}


import { connect } from "react-redux";
const mapState = state => ({
  practices_data: state.overview.practices_data
});

const mapDispatch = ({
  overview: { loadData } }) => ({
    loadData: () => loadData()
  });

export default connect(mapState, mapDispatch)(AppPracticePrescriptions2);

